export function buildAction(action, payload) {
  const data = {
    type: action,
  };

  if (payload !== undefined) {
    data.payload = payload;
  }

  return data;
}

export function delayedAction(minimumTime, workFunction) {
  // Minimum time before dispatching success.
  // You're welcome @ehoekendorf 😘.
  const soonest = Date.now() + minimumTime;

  return new Promise((resolve, reject) => {
    Promise.resolve(workFunction()).then(result => {
      const delay = soonest - Date.now();
      setTimeout(() => {
        resolve(result);
      }, Math.max(delay, 0));
    });
  });
}

export function fakeProgress(update, maxTime = 2500, fps = 25) {
  const msStep = 1 / maxTime;
  const delay = 1000 / 25; // FPS.

  let last = Date.now();
  let progress = 0;

  const step = function() {
    const now = Date.now();
    const timeDelta = now - last;
    last = now;

    const progressDelta = msStep * timeDelta * (1 - progress);
    progress = progress + progressDelta;
    update(progressDelta, progress);
  };

  const interval = setInterval(step, delay);

  return () => clearInterval(interval);
}



// WEBPACK FOOTER //
// ./src/actions/helpers.js